"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPreset = exports.TOPBAR_ACTION_LIST = exports.SIDE_MENUS_ORDER_LIST = exports.PRESET_INITIAL_CONFIG = exports.PRESET_FORCE_CONFIG = exports.MODERN_VIEWER_TOPBAR_READ_ALOUD_ACTION_LIST = exports.MODERN_VIEWER_TOPBAR_ANNOTATION_TOOL_IDS = exports.MODERN_VIEWER_TOPBAR_ACTION_LIST = exports.MODERN_VIEWER_SIDE_MENUS_ORDER_LIST = exports.MODERN_VIEWER_INITIAL_CONFIG = exports.MODERN_VIEWER_CONFIG = exports.MISSING_STATUS_CALLBACK_CONFIG = exports.MISSING_SAVE_CALLBACK_CONFIG = exports.MISSING_MODERN_VIEWER_SAVE_CALLBACK_CONFIG = exports.INITIAL_CONFIG = exports.INITIAL_ACTION_CONFIG = exports.DEFAULT_STATUS_CALLBACK_CONFIG = exports.DEFAULT_SAVE_CALLBACK_CONFIG = exports.DEFAULT_MODERN_VIEWER_SAVE_CALLBACK_CONFIG = exports.ANNOTATION_TOOL_TYPE_IDS = exports.ANNOTATION_TOOL_IDS = void 0;
var _ViewMode = require("./ViewMode");
var _Enums = require("./Enums");
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const defaultPreset = exports.defaultPreset = _ViewMode.Preset.FULL_WINDOW;
const INITIAL_CONFIG = exports.INITIAL_CONFIG = {
  showTopBar: false,
  showBrandingTitle: true,
  showLegalNotice: false,
  leftAlignFileName: false,
  showFileLoadingProgress: true,
  showSimpleLoader: false,
  showUploadFileLoader: false,
  fullScreenLoader: false,
  supportUrl: "",
  integrationName: "",
  localizationStrings: {},
  externalJSComponentURL: "",
  takeActionOnInternalEvents: true,
  workOnInLineIndependently: true,
  supportDarkMode: false,
  fileDownloadAbortable: false,
  isViewSDKPublic: false,
  toolsDropinList: [],
  toolsBoardRequired: true,
  editingIsRequired: false,
  enablePDFJavaScript: false,
  enableKillSwitch: false,
  enableOverprintSupport: false,
  env: "prod",
  linearizationBlockSize: 65536,
  // 64KB
  fileRenderingTimeout: 300000,
  // 5 minutes,
  renderWithV2SpectrumProvider: true,
  isIsolationRequired: true
};
const INITIAL_ACTION_CONFIG = exports.INITIAL_ACTION_CONFIG = {
  preview: {
    embedMode: defaultPreset,
    assetType: "/external",
    showAnnotationTools: true,
    enableAnnotationAPIs: false,
    enableSearchAPIs: false,
    includePDFAnnotations: false,
    showLeftHandPanel: true,
    showPageControls: true,
    showDownloadPDF: true,
    showPrintPDF: true,
    showFitPageButton: true,
    showFitWidthButton: true,
    showFullScreenViewButton: true,
    viewWithScrollButton: {
      visible: true,
      active: true
    },
    showRotateViewControl: false,
    showZoomControl: true,
    showPageNavigationControl: true,
    defaultViewMode: "",
    enableFormFilling: true,
    docViewBgColor: "var(--spectrum-global-color-gray-400) !important",
    showFullScreenInHUD: false,
    localizationStrings: {},
    postDraftCommentOnConflict: false,
    annotationUIConfig: {
      // downloadWithAnnotations: false,
      // printWithAnnotations: false,
      // showCommentsPanel: true,
      // showToolsOnTextSelection: true,
      // showToolbar: true,
    },
    shouldRenderCommentsDropin: false,
    shouldRenderSignAuthoringDropin: false,
    shouldRenderVisualizerDropin: false,
    disableContextMenuAutoTrigger: false,
    selectivelyRenderAnnotsFlag: undefined,
    shouldDisableDownloadInContextMenu: false,
    adjustSearchUI: true,
    adjustSearchUIBelowTopBar: true,
    alternateAssetUri: "",
    // ---------------------------------------------------------------
    // TODO:: clean up below 5 temp flags (currently only in use by Viewer dropin)
    // ---------------------------------------------------------------
    dcapiRenditionSize: 800,
    dcapiRenditionFormat: "png",
    // ---------------------------------------------------------------
    uiActionConfig: [],
    fixedWidthLeftMargin: undefined,
    fixedWidthRightMargin: undefined,
    hudBottomMargin: undefined,
    showViewMode: false,
    showFileNameToast: undefined,
    firstTimeEnterEdit: false,
    showScrubber: undefined,
    disableUnsupportedFeatureAlert: false,
    enableModernViewer: false,
    enableEraserAnnotationTool: false,
    enableFreeTextAnnotationTool: true,
    enableLinearization: false,
    enableCNPDF: false,
    showPreviewHomeButton: false,
    linearizationConfig: {
      makeMultipartRangeCalls: false,
      initiateEarlyFileDownload: true
    },
    enableEdit: false,
    usePartialEdit: false,
    usePremiumIndicator: false,
    isDemoMode: false,
    showEditOnTextSelection: true,
    shouldEnableEditGenAI: false,
    showAdvancedFontPicker: false,
    disableEditFeatures: {
      disableFormatText: false,
      disableBBox: false
    },
    enableNumberPages: false,
    enableCropPages: false,
    saveBeforeUnload: false,
    useIframelessPrint: false,
    enableInlineOrganize: false,
    disableProtectedPDFCancelButton: false,
    printStrategy: _Enums.printStrategy.BROWSER_PRINT,
    editDeepLink: false,
    defaultRHPFeature: "",
    enableFillSign: false,
    enablePdfRequestSignatures: false,
    forceSetExternalMetadata: true,
    showBookmarks: true,
    showThumbnails: true,
    showAssistantInRHP: false,
    enableReadAloud: false,
    emitSubmitFormEvent: false,
    openInDesktopForUnsupportedFeature: false,
    enableCaretMode: false,
    scrollToShowCaret: true,
    showCaretOnPDFOpen: true,
    enableEncryptedWrite: false,
    suppressPasswordDialog: false,
    enableCustomLoader: undefined,
    enableAccessibilityByDefault: false,
    enableMobileModernViewer: false,
    enableAcroformValidationFormatting: true,
    thumbnailSecondaryHeaderVerbs: [],
    filePath: undefined,
    sharedCommentingMode: false,
    isSharedFileMode: false,
    fillSignConfig: {},
    showPremiumIconForNonDCWebClients: false,
    shouldUseProgressiveRendering: false,
    digitalSignatureConfig: {
      enableValidation: false,
      enableBannerVisibility: false,
      externalCertificateValidator: null
    },
    genAIConfig: {
      enableQnA: false,
      enableOutline: false
    },
    showDocumentPermissionsToast: false,
    hideStickyToolOnTap: false,
    enableThemeSwitcher: false,
    viewDocumentProperties: true,
    enableRHPResizing: false,
    fallbackPrintTimeout: _Enums.DEFAULT_FALLBACK_PRINT_TIMEOUT_INTERVAL,
    shouldRenderESignOverlayDropin: false,
    pinToolConfig: {
      showPinTool: false,
      showPinTooltip: false
    },
    shouldDeferLoadOverlays: false,
    customReadingThemesSet: [],
    rhpSkeletonDropinId: "",
    bottomBannerConfig: {
      dropinId: undefined,
      isSharedFile: undefined
    },
    renderNotificationBannerBeforeDoc: false
  }
};
const DEFAULT_STATUS_CALLBACK_CONFIG = exports.DEFAULT_STATUS_CALLBACK_CONFIG = {
  autoSaveFrequency: 30,
  filePollFrequency: 10,
  enableFocusPolling: true,
  keepPolling: false
};
const MISSING_STATUS_CALLBACK_CONFIG = exports.MISSING_STATUS_CALLBACK_CONFIG = {
  autoSaveFrequency: 0,
  filePollFrequency: 0,
  enableFocusPolling: false,
  keepPolling: false
};
const DEFAULT_SAVE_CALLBACK_CONFIG = exports.DEFAULT_SAVE_CALLBACK_CONFIG = {
  incremental: false,
  autoSaveFrequency: 0,
  enableFocusPolling: false,
  showSaveButton: true,
  showError: true,
  showEditStatusInfo: true
};
const MISSING_SAVE_CALLBACK_CONFIG = exports.MISSING_SAVE_CALLBACK_CONFIG = {
  incremental: false,
  autoSaveFrequency: 0,
  enableFocusPolling: false,
  showSaveButton: true,
  showError: true,
  showEditStatusInfo: true
};
const DEFAULT_MODERN_VIEWER_SAVE_CALLBACK_CONFIG = exports.DEFAULT_MODERN_VIEWER_SAVE_CALLBACK_CONFIG = {
  incremental: false,
  autoSaveFrequency: 0,
  enableFocusPolling: false,
  showSaveButton: true,
  showError: true,
  showEditStatusInfo: true
};
const MISSING_MODERN_VIEWER_SAVE_CALLBACK_CONFIG = exports.MISSING_MODERN_VIEWER_SAVE_CALLBACK_CONFIG = {
  incremental: false,
  autoSaveFrequency: 0,
  enableFocusPolling: false,
  showSaveButton: true,
  showError: true,
  showEditStatusInfo: true
};
const PRESET_INITIAL_CONFIG = exports.PRESET_INITIAL_CONFIG = {
  INTEGRATION: {
    config: {
      backgroundColor: "#eaeaea",
      showBranding: true,
      showPreviewErrors: false
    },
    actionConfig: {
      showFullScreen: false
    }
  },
  FULL_WINDOW: {
    config: {
      backgroundColor: "#eaeaea",
      showBranding: true
    },
    actionConfig: {
      showFullScreen: false,
      dockPageControls: true
    }
  },
  LIGHT_BOX: {
    config: {
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      showBranding: true
    },
    actionConfig: {
      exitPDFViewerType: _ViewMode.LightBoxExitPDFViewerType.CLOSE,
      showFullScreen: false,
      dockPageControls: false
    }
  },
  SIZED_CONTAINER: {
    config: {
      backgroundColor: "#eaeaea",
      showBranding: true
    },
    actionConfig: {
      showFullScreen: true,
      dockPageControls: true
    }
  },
  IN_LINE: {
    config: {
      backgroundColor: "#fff",
      showBranding: true
    },
    actionConfig: {
      showFullScreen: false
    }
  }
};
const PRESET_FORCE_CONFIG = exports.PRESET_FORCE_CONFIG = {
  INTEGRATION: {
    config: {
      showTopBar: true,
      leftAlignFileName: false,
      backgroundColor: "#eaeaea",
      externalJSComponentURL: ""
    },
    actionConfig: {
      exitPDFViewerType: "",
      enableBookmarkAPIs: true,
      enableAttachmentAPIs: true,
      showFullScreen: false,
      dockPageControls: false,
      showDownloadPDFInPageControl: false,
      showFullScreenInHUD: false,
      enableLinearization: false,
      enableCNPDF: false,
      usePartialEdit: false,
      usePremiumIndicator: false,
      shouldEnableEditGenAI: false,
      showAdvancedFontPicker: false,
      disableEditFeatures: {
        disableFormatText: false,
        disableBBox: false
      },
      enableNumberPages: false,
      firstTimeEnterEdit: false
    }
  },
  FULL_WINDOW: {
    config: {
      leftAlignFileName: true,
      showBrandingTitle: false,
      supportUrl: "",
      integrationName: "",
      localizationStrings: {}
    },
    actionConfig: {
      exitPDFViewerType: "",
      showDownloadPDFInPageControl: false,
      enableBookmarkAPIs: true,
      enableAttachmentAPIs: true,
      showFullScreenInHUD: false,
      localizationStrings: {},
      useIframelessPrint: false
    }
  },
  LIGHT_BOX: {
    config: {
      leftAlignFileName: true,
      showBrandingTitle: false,
      supportUrl: "",
      integrationName: "",
      localizationStrings: {}
    },
    actionConfig: {
      showAnnotationTools: false,
      enableAnnotationAPIs: false,
      enableBookmarkAPIs: false,
      enableAttachmentAPIs: false,
      includePDFAnnotations: false,
      enableFormFilling: false,
      showLeftHandPanel: false,
      showDownloadPDFInPageControl: false,
      showFullScreenInHUD: false,
      showFullScreen: false,
      localizationStrings: {},
      adjustSearchUI: false,
      enableLinearization: false,
      enableCNPDF: false,
      enableEdit: false,
      useIframelessPrint: false,
      usePartialEdit: false,
      usePremiumIndicator: false,
      shouldEnableEditGenAI: false,
      showAdvancedFontPicker: false,
      disableEditFeatures: {
        disableFormatText: false,
        disableBBox: false
      },
      enableNumberPages: false,
      firstTimeEnterEdit: false
    }
  },
  SIZED_CONTAINER: {
    config: {
      leftAlignFileName: true,
      showBrandingTitle: false,
      supportUrl: "",
      integrationName: "",
      localizationStrings: {},
      externalJSComponentURL: ""
    },
    actionConfig: {
      exitPDFViewerType: "",
      showAnnotationTools: false,
      enableAnnotationAPIs: false,
      enableBookmarkAPIs: false,
      enableAttachmentAPIs: false,
      includePDFAnnotations: false,
      enableFormFilling: false,
      showLeftHandPanel: false,
      showPageControls: true,
      showFitPageButton: false,
      showFitWidthButton: false,
      showRotateViewControl: false,
      showZoomControl: false,
      defaultViewMode: "SINGLE_PAGE",
      showFullScreenInHUD: true,
      showDownloadPDFInPageControl: false,
      showPageNavigationControl: true,
      localizationStrings: {},
      adjustSearchUI: false,
      enableLinearization: false,
      enableCNPDF: false,
      enableEdit: false,
      useIframelessPrint: false,
      usePartialEdit: false,
      usePremiumIndicator: false,
      shouldEnableEditGenAI: false,
      showAdvancedFontPicker: false,
      disableEditFeatures: {
        disableFormatText: false,
        disableBBox: false
      },
      enableNumberPages: false,
      firstTimeEnterEdit: false
    }
  },
  IN_LINE: {
    config: {
      leftAlignFileName: true,
      showTopBar: false,
      showBrandingTitle: false,
      supportUrl: "",
      integrationName: "",
      localizationStrings: {},
      externalJSComponentURL: ""
    },
    actionConfig: {
      exitPDFViewerType: "",
      showAnnotationTools: false,
      enableAnnotationAPIs: false,
      enableBookmarkAPIs: false,
      enableAttachmentAPIs: false,
      includePDFAnnotations: false,
      enableFormFilling: false,
      showLeftHandPanel: false,
      showPageControls: true,
      dockPageControls: false,
      showFitPageButton: false,
      showFitWidthButton: false,
      defaultViewMode: "IN_PLACE",
      showFullScreen: false,
      showFullScreenInHUD: false,
      showRotateViewControl: false,
      showZoomControl: false,
      showDownloadPDFInPageControl: true,
      showPageNavigationControl: true,
      localizationStrings: {},
      adjustSearchUI: false,
      enableLinearization: false,
      enableCNPDF: false,
      enableEdit: false,
      useIframelessPrint: false,
      showBookmarks: false,
      showThumbnails: false,
      usePartialEdit: false,
      usePremiumIndicator: false,
      showAdvancedFontPicker: false,
      disableEditFeatures: {
        disableFormatText: false,
        disableBBox: false
      },
      enableNumberPages: false,
      firstTimeEnterEdit: false,
      digitalSignatureConfig: {
        enableValidation: false,
        enableBannerVisibility: false,
        externalCertificateValidator: null
      }
    }
  }
};
const MODERN_VIEWER_INITIAL_CONFIG = exports.MODERN_VIEWER_INITIAL_CONFIG = {
  FULL_WINDOW: {
    config: {
      backgroundColor: "var(--bgColor)"
    },
    actionConfig: {}
  },
  SIZED_CONTAINER: {
    config: {},
    actionConfig: {}
  },
  LIGHT_BOX: {
    config: {
      backgroundColor: "var(--bgColorLB)"
    },
    actionConfig: {}
  },
  IN_LINE: {
    config: {
      backgroundColor: "var(--spectrum-global-color-gray-50)"
    },
    actionConfig: {}
  }
};
const MODERN_VIEWER_CONFIG = exports.MODERN_VIEWER_CONFIG = {
  FULL_WINDOW: {
    config: {
      leftAlignFileName: false
    },
    actionConfig: {
      showLeftHandPanel: false,
      enableModernViewer: true
    }
  },
  SIZED_CONTAINER: {
    config: {
      showTopBar: false,
      leftAlignFileName: false
    },
    actionConfig: {
      showFileNameToast: true,
      enableModernViewer: true,
      showAnnotationTools: false,
      showFitPageButton: true,
      showFitWidthButton: true,
      showZoomControl: true
    }
  },
  LIGHT_BOX: {
    config: {
      leftAlignFileName: false
    },
    actionConfig: {
      enableModernViewer: true,
      enableAttachmentAPIs: true,
      enableBookmarkAPIs: true
    }
  },
  IN_LINE: {
    config: {},
    actionConfig: {
      enableModernViewer: true,
      showPreviewHomeButton: false
    }
  }
};
const ANNOTATION_TOOL_TYPE_IDS = exports.ANNOTATION_TOOL_TYPE_IDS = ["stickyNote", "highlight", "freehandTool", "freetext", "eraserTool"];
const ANNOTATION_TOOL_IDS = exports.ANNOTATION_TOOL_IDS = [...ANNOTATION_TOOL_TYPE_IDS];
const TOPBAR_ACTION_LIST = exports.TOPBAR_ACTION_LIST = ["undo", "redo", "freetext", "stickyNote", "highlight", "freehandTool", "eraserTool", "documentSearch", "documentPrint"];
const MODERN_VIEWER_TOPBAR_ANNOTATION_TOOL_IDS = exports.MODERN_VIEWER_TOPBAR_ANNOTATION_TOOL_IDS = ["undo", "redo"];
const MODERN_VIEWER_TOPBAR_ACTION_LIST = exports.MODERN_VIEWER_TOPBAR_ACTION_LIST = ["readAloudStart", "undo", "redo", "documentSearch", "documentPrint"];
const MODERN_VIEWER_TOPBAR_READ_ALOUD_ACTION_LIST = exports.MODERN_VIEWER_TOPBAR_READ_ALOUD_ACTION_LIST = ["readAloudIcon", "readAloudFileName", "readAloudRatePicker", "readAloudPrev", "readAloudPlayPause", "readAloudNext", "readAloudVoicePicker", "readAloudStop"];
const SIDE_MENUS_ORDER_LIST = exports.SIDE_MENUS_ORDER_LIST = ["stickyNote", "highlight", "freehandTool", "eraserTool", "documentSearch", "documentDownload", "documentPrint"];
const MODERN_VIEWER_SIDE_MENUS_ORDER_LIST = exports.MODERN_VIEWER_SIDE_MENUS_ORDER_LIST = ["readAloudStart", "documentPrint", "documentDownload"];